<small
  class="p-error"
  *ngIf="
    control &&
    errorMsg &&
    control.errors &&
    control.errors[errorName] &&
    (control.dirty || control.touched || isShowError)
  "
>
  {{ errorMsg | translate: { fieldName: fieldName | translate } }}
</small>
